import React from 'react';
import { MContactUsProps } from './MContactUs.types';
import { StyledWrapper, StyledLinkAddressWrapper } from './MContactUs.styles';
import { ASubheader, ASubheaderSize, ASubheaderTag } from '../../atoms/ASubheader';
import { ALinkStandalone } from '../../atoms/ALinkStandalone';
import { MListNav } from '../MListNav';

export function MContactUs({ aSubheader, mLinkAddress, mListNav }: MContactUsProps) {
  return (
    <StyledWrapper data-testid="m-contact-us">
      {aSubheader?.text && (
        <ASubheader
          text={aSubheader.text}
          size={aSubheader.size || ASubheaderSize.M}
          element={aSubheader.element || ASubheaderTag.h2}
        />
      )}

      {mLinkAddress?.text && mLinkAddress?.href && (
        <StyledLinkAddressWrapper>
          <ALinkStandalone text={mLinkAddress.text} href={mLinkAddress.href} />
        </StyledLinkAddressWrapper>
      )}

      {mListNav && mListNav.length > 0 && mListNav.map((navProps, index) => <MListNav key={index} {...navProps} />)}
    </StyledWrapper>
  );
}
